import { Component, OnInit } from '@angular/core';
import { ComplaintsService } from './core/services/complaints.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
	constructor(
		private complaintsService: ComplaintsService,
		private translate: TranslateService
	) {
		translate.setDefaultLang('pt-BR');
		translate.use('pt-BR');
	}

	ngOnInit(): void {
		this.complaintsService.setEmergencyListener();
	}
}
